import { getAjaxConfig, IAjaxResponse } from "../../api";
import { HttpService } from "../../packages/HttpService";
import { IDictItem } from "components/forms/model";
import { useState, useEffect } from "react";

/**
 * 滑动验证（No-Captcha，简称NC）
 */
export interface INcParams {
  sessionId: string;
  sig: string;
  token: string;
  scene: string;
}

export interface ICorporateIntention {
  /**
   * 公司名
   */
  companyName: string;
  /**
   * 公司所在地
   */
  registeredAddress: string;
  /**
   * 姓名
   */
  name: string;
  /**
   * 手机号码
   */
  telephoneNum: string;
  /**
   * 邮箱
   */
  email: string;
  /**
   * 公司业务类型
   */
  companyBizTypeList: ReadonlyArray<string>;
  /**
   * 了解渠道
   */
  companyServicedIndustryList: ReadonlyArray<string>;
}

export type IFetchCreateIntentionRequest = ICorporateIntention & INcParams;

/**
 * 用户意向提交
 */
export const fetchCreateIntention = async (
  requestBody: IFetchCreateIntentionRequest
) => {
  return HttpService.post<IAjaxResponse<boolean>>(
    `/api/biz/intention`,
    requestBody,
    getAjaxConfig()
  );
};

export interface ICorporateDicts {
  registeredAddress: ReadonlyArray<IDictItem>;
  consultIndustryType: ReadonlyArray<IDictItem>;
  companyBizType: ReadonlyArray<IDictItem>;
  companyServicedIndustry: ReadonlyArray<IDictItem>;
  learnAboutChannel: ReadonlyArray<IDictItem>;
}

/**
 * 创建字典
 */
export const fetchDictionary = async () => {
  return HttpService.get<IAjaxResponse<ICorporateDicts>>(
    `/api/biz/dictionary`,
    {},
    getAjaxConfig()
  );
};

const initDicts = {
  companyBizType: [] as ReadonlyArray<IDictItem>,
  companyServicedIndustry: [] as ReadonlyArray<IDictItem>,
  registeredAddress: [] as ReadonlyArray<IDictItem>,
  learnAboutChannel: [] as ReadonlyArray<IDictItem>,
  consultIndustryType: [] as ReadonlyArray<IDictItem>
};

export const useCorporateDicts = () => {
  const [dicts, setDicts] = useState(initDicts);
  useEffect(() => {
    fetchDictionary().then(resp => {
      if (resp.success) {
        setDicts(resp.data);
      }
    });
  }, []);
  return dicts;
};
